export default {
  mounted() {
    this.el.focus()

    // Create a range object
    var range = document.createRange()
    // Get the contentEditable element's last child node
    var lastChild = this.el.lastChild
    // Set the range to the end of the content
    range.setStartAfter(lastChild) // Assumes there is at least one child node
    // Make the window's selection range equal to the range object
    var selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)

    // // Move the cursor to the end of the text in the input
    // const value = this.el.value // Get the current value of the input
    // this.el.value = '' // Temporarily clear the value
    // this.el.value = value // Re-assign the value to move cursor to the end

    // Create a hidden input element
    const hiddenInput = document.createElement('input')
    hiddenInput.type = 'hidden'
    hiddenInput.name = this.el.dataset.name
    hiddenInput.value = this.el.innerHTML // Or innerText, depending on what you want to capture
    // Append it to the form or a parent container. Adjust the selector as needed.
    this.el.parentNode.appendChild(hiddenInput)

    this.el.addEventListener('input', (_event) => {
      hiddenInput.value = this.el.innerText // Or innerText, depending on what you want to capture
    })

    const submit = () => {
      if (this.el.dataset.blur) {
        this.pushEventTo(this.el, this.el.dataset.blur, { value: this.value() })
      }
    }

    this.el.addEventListener('blur', submit)

    if (this.el.hasAttribute('data-singleline')) {
      // Ensure we paste the plain text version of whatever was on your clipboard
      this.el.addEventListener('paste', (e) => {
        e.preventDefault()
        const event = (e.originalEvent || e)
        const text = event.clipboardData.getData('text/plain').trim().replaceAll("\n", " ")

        if (document.queryCommandSupported('insertText')) {
          document.execCommand('insertText', false, text);
        } else if (document.queryCommandSupported('paste')) {
          document.execCommand('paste', false, text);
        } else {
          document.selection.createRange().pasteHTML(text);
        }
      })
    }

    if (this.el.dataset.singleline !== undefined) {
      this.el.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === 'Escape') {
          event.preventDefault()
          submit()
        }
      })
    }
  },
  value() {
    var txt = document.createElement('textarea')
    txt.innerHTML = this.el.innerText
    return txt.value
  },
}
